import { Button } from '@accure/ui';

import { useAddWorkstreamModal } from '@/project-management/modals/add-workstream';

export function TimelineEmpty() {
  const showAddWorkstreamModal = useAddWorkstreamModal();

  return (
    <div className="w-full flex-col items-center justify-center p-6 text-center">
      <h3 className="mb-2 text-lg font-medium text-gray-900">
        No workstreams to display
      </h3>
      <p className="mb-4 text-gray-600">
        Create your first workstream to see the project timeline.
      </p>
      <Button
        onClick={() => showAddWorkstreamModal('template')}
        size="sm"
        className=""
      >
        + Create Workstream
      </Button>
    </div>
  );
}
